module.exports = __webpack_public_path__ + "static/media/education.44a2c8ae.svg";